"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionStyles = void 0;
const getSectionFlexBasisStyles_1 = require("./getSectionFlexBasisStyles");
const sizeToString_1 = require("./sizeToString");
const getSectionStyles = ({ config, modelValue, isColumnDirection, hasDefaultFlexBasisStyle }) => {
    var _a;
    const hasSize = (_a = config === null || config === void 0 ? void 0 : config.size) !== null && _a !== void 0 ? _a : 0 > 0;
    const hasGrow = !hasSize && !(modelValue === null || modelValue === void 0 ? void 0 : modelValue.shouldApply);
    return {
        flexGrow: hasGrow ? 1 : 0,
        flexBasis: (0, getSectionFlexBasisStyles_1.getSectionFlexBasisStyles)({
            size: config === null || config === void 0 ? void 0 : config.size,
            modelValue,
            isColumnDirection,
            hasDefaultFlexBasisStyle
        }),
        minWidth: (0, sizeToString_1.sizeToString)(config === null || config === void 0 ? void 0 : config.minSize),
        maxWidth: (0, sizeToString_1.sizeToString)(config === null || config === void 0 ? void 0 : config.maxSize)
    };
};
exports.getSectionStyles = getSectionStyles;
//# sourceMappingURL=getSectionStyles.js.map